export default __webpack_public_path__ + "static/media/JetBrains.ddb21c23.svg";